import { ListOrdered } from "lucide-react";
import { SequenceManager } from "@/components/sequences/SequenceManager";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { SavedSequencesTab } from "./SavedSequencesTab";

export const SequencesTab = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <ListOrdered className="h-5 w-5 text-primary" />
        <h2 className="text-2xl font-bold tracking-tight">Email Sequences</h2>
      </div>
      
      <Tabs defaultValue="builder" className="space-y-4">
        <TabsList>
          <TabsTrigger value="builder">Sequence Builder</TabsTrigger>
          <TabsTrigger value="saved">Saved Sequences</TabsTrigger>
        </TabsList>

        <TabsContent value="builder">
          <SequenceManager />
        </TabsContent>

        <TabsContent value="saved">
          <SavedSequencesTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};